import styled from "styled-components"
import is from "styled-is"

export const Header = styled.header`
  border-top: 3px solid #282828;
  background-color: #fff;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  height: 50px;

  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 99;
  overflow: hidden;
  transition: height 0.56s cubic-bezier(0.52, 0.16, 0.24, 1);

  ${is("visible")`
    height: 198px;
    transition: height .56s cubic-bezier(0.52, 0.16, 0.24, 1);
  `};

  @media screen and (min-width: 768px) {
    z-index: 0;
    height: 86px;
    position: relative;
  }
`

export const LandingWrapperHeader = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 8px;
  box-sizing: border-box;

  @media screen and (min-width: 768px) {
    display: flex;
    justify-content: space-between;
    height: 100%;
  }

  @media screen and (min-width: 1200px) {
    padding: 0;
  }
`

export const Logo = styled.img`
  width: 86px;
  display: flex;
  justify-content: space-between;

  @media screen and (min-width: 768px) {
    width: 154px;
  }
`

export const BurgerMenu = styled.button`
  border: none;

  @media screen and (min-width: 768px) {
    display: none;
  }
`

export const MenuView = styled.div`
  height: 50px;
  display: flex;
  justify-content: space-between;

  @media screen and (min-width: 768px) {
    height: 100%;
  }
`

export const ActionsView = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (min-width: 768px) {
    flex-direction: row;
  }
`

export const MenuList = styled.ul`
  border-top: 1px solid #ebebeb;
  list-style-type: none;
  display: block;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  opacity: 0;
  transition: opacity 0.6s cubic-bezier(0.52, 0.16, 0.24, 1) 0.1s,
    visibility 0s linear 0.5s;

  ${is("visible")`
    opacity: 1;
    transition: opacity .18s cubic-bezier(0.32, 0.08, 0.24, 1) .18s,visibility 0s linear 0s;
  `};

  @media screen and (min-width: 768px) {
    opacity: 1;
    transition: none;
    display: flex;
  }
`

export const MenuListItem = styled.li`
  margin: 0;
  padding: 0;
`

export const MenuListItemButton = styled.a`
  font-family: "Open Sans", sans-serif;
  margin: 0;
  border: none;
  color: #282828;
  background-color: transparent;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #ebebeb;
  padding: 14px 0;
  font-size: 14px;
  outline: none;
  text-decoration: none;
  cursor: pointer;

  @media screen and (min-width: 768px) {
    font-size: 20px;
    height: 100%;
    padding: 0 24px;
    border-bottom: 3px solid transparent;
    transition: all 250ms ease-in-out;

    &:hover {
      background: rgba(248, 245, 245, 1);
      border-bottom: 3px solid rgba(0, 198, 199, 1);
    }
  }
`

export const MenuAccess = styled.a`
  color: #282828;
  padding: 8px 30px;
  margin: 30px auto;
  display: inherit;
  font-size: 14px;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
  border: 1px solid #282828;
  text-decoration: none;
  border-radius: 2px;
  background-color: transparent;
  outline: none;
  cursor: pointer;

  @media screen and (min-width: 768px) {
    margin: 24px 0 24px 24px;
  }
`
